import React from 'react';
import { CheckCircle2, ArrowUpCircle, ArrowDownCircle } from 'lucide-react';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

/**
 * What the Changes tab says when nothing is edited since the last sync. It
 * reads the same `git_status` the status pill (describeSync) does, so the two
 * never contradict (owner's data, 07.10.2026: "Changes waiting" in the pill,
 * "Everything is synced" in the tab — a version committed, never pushed).
 * A local history has no remote: ahead / behind mean nothing there.
 */
export function nothingEditedState(status, words) {
  const ahead = words.local ? 0 : status?.ahead || 0;
  const behind = words.local ? 0 : status?.behind || 0;
  if (ahead > 0) {
    return {
      tone: 'waiting',
      icon: ArrowUpCircle,
      title: `${plural(ahead, 'version')} not sent yet`,
      sub: `Nothing is edited since ${words.last}, but ${ahead === 1 ? 'a version is' : 'versions are'} only on this device. ${words.action} sends ${ahead === 1 ? 'it' : 'them'}.`,
    };
  }
  if (behind > 0) {
    return {
      tone: 'waiting',
      icon: ArrowDownCircle,
      title: `${plural(behind, 'update')} on the remote`,
      sub: `Nothing is edited here. Pull brings ${behind === 1 ? 'it' : 'them'} in.`,
    };
  }
  return { tone: 'ok', icon: CheckCircle2, title: words.local ? 'Everything is saved' : 'Everything is synced', sub: `No changes since ${words.last}` };
}

export default function GitNothingEdited({ status, words }) {
  const { tone, icon: Icon, title, sub } = nothingEditedState(status, words);
  return (
    <div className={`git-synced${tone === 'waiting' ? ' git-synced--waiting' : ''}`} data-testid="git-nothing-waiting" data-tone={tone}>
      <Icon size={28} aria-hidden />
      <span className="git-synced-title">{title}</span>
      <span className="git-synced-sub">{sub}</span>
    </div>
  );
}
